import React, { useEffect, useState } from 'react';
import PricingCard from './PricingCard';
import serverConfig from 'config/server.config';
import listService from 'services/list.service';
import ipService from 'services/ip.service';
import PricingCardHorizontal from './PricingCardHorizontal';
//https://buy.stripe.com/test_4gwg2e95ygoz0uc9AE
//https://buy.stripe.com/9AQbIT1iX3a3dKEbII

const PricingSection = () => {
    const [currency, setCurrency] = useState('$');
    useEffect(() => {
        ipService.getIp()
            .then(response => {
                listService.getCurrency(response)
                    .then(response => {
                        setCurrency(response.data.currency);
                    })
                    .catch(error => {
                        //do nothing
                    });
            })
            .catch(error => {
                //do nothing
            });
    }, []);

    return (
        <section id='pricing' className="bg-gray-50 dark:bg-gray-900 flex min-h-screen items-center">
            <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 w-full">
                <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 md:space-y-0 mb-8 md:mb-4">
                    {/* Pricing Card */}
                    <PricingCard
                        title="MapList Free"
                        action='@maplistbot'
                        description=''
                        link='https://x.com/maplistbot'
                        currency={currency}
                        price={0}
                        features={[
                            { isAvailable: true, text: `Generate Google Maps Lists`, detail: '' },
                            { isAvailable: true, text: `Max number of places: `, detail: '10' },
                            { isAvailable: false, text: `"Add to list" prompt`, detail: '' },
                            { isAvailable: false, text: `Edit Rights for Lists`, detail: '' },
                            { isAvailable: false, text: `Generated Lists include comments`, detail: '' },
                            { isAvailable: false, text: `Create Filtered Lists`, detail: '' },
                        ]}
                    />
                    <PricingCard
                        title="MapList Pro Monthly"
                        action='GET PRO'
                        description=''
                        type='monthly'
                        link={`${serverConfig.PAY_LINK_MONTHLY}`}
                        currency={currency}
                        price={serverConfig.PRICE_MONTHLY}
                        features={[
                            { isAvailable: true, text: `Generate Google Maps Lists`, detail: '' },
                            { isAvailable: true, text: `Max number of places: `, detail: 'unlimited' },
                            { isAvailable: true, text: `"Add to list" prompt`, detail: '' },
                            { isAvailable: true, text: `Edit Rights for Lists`, detail: '' },
                            { isAvailable: true, text: `Generated Lists include comments`, detail: '' },
                            { isAvailable: true, text: `Create Filtered Lists`, detail: '' },
                        ]}
                    />
                    <PricingCard
                        title="MapList Pro Yearly"
                        action='GET PRO'
                        description=''
                        type='yearly'
                        link={`${serverConfig.PAY_LINK_YEARLY}`}
                        currency={currency}
                        price={serverConfig.PRICE_YEARLY}
                        features={[
                            { isAvailable: true, text: `Generate Google Maps Lists`, detail: '' },
                            { isAvailable: true, text: `Max number of places: `, detail: 'unlimited' },
                            { isAvailable: true, text: `"Add to list" prompt`, detail: '' },
                            { isAvailable: true, text: `Edit Rights for Lists`, detail: '' },
                            { isAvailable: true, text: `Generated Lists include comments`, detail: '' },
                            { isAvailable: true, text: `Create Filtered Lists`, detail: '' },
                        ]}
                    />
                </div>
                <PricingCardHorizontal
                    title="MapList Pro Lifetime"
                    action='GET PRO'
                    description="I don't like subscriptions. I want to pay once and use it forever."
                    link={`${serverConfig.PAY_LINK_LIFETIME}`}
                    currency={currency}
                    price={serverConfig.PRICE_LIFETIME}
                />
            </div>
        </section>
    );
};

export default PricingSection;